import { axios } from '@Root/API'

export const putHesa = (programmeId, data) => {
  return axios.put(`program/${programmeId}/hesa`, data)
}
